import {
  SET_SUBMIT_STATUS,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_INIT,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_RESET,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_SUCCESS,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_ACCEPTANCE,
  SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_SIGNATURE
} from './SLUAgreementActions';

export const SUBMIT_STATUS_NONE = 'NONE';
export const SUBMIT_STATUS_IN_PROGRESS = 'IN PROGRESS';
export const SUBMIT_STATUS_SUCCESS = 'SUCCESS';
export const SUBMIT_STATUS_FAILURE = 'FAILURE';

const initialState = {
  submitStatus: SUBMIT_STATUS_NONE,
  userSignature: '',
  userAcceptance: false,
  emailEnabled: true
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_INIT:
      return {
        ...initialState
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT:
      return {
        ...state,
        submitStatus: SUBMIT_STATUS_IN_PROGRESS
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_RESET:
      return {
        ...state,
        submitStatus: SUBMIT_STATUS_NONE
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_SUCCESS:
      return {
        ...state,
        submitStatus: SUBMIT_STATUS_SUCCESS
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_SUBMIT_FAILURE:
      return {
        ...state,
        submitStatus: SUBMIT_STATUS_FAILURE
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_SIGNATURE:
      return {
        ...state,
        userSignature: action.payload
      };
    case SURVEY_LIBRARY_UPDATE_AGREEMENT_UPDATE_ACCEPTANCE:
      return {
        ...state,
        userAcceptance: !state.userAcceptance
      };
    case SET_SUBMIT_STATUS:
      return {
        ...state,
        submitStatus: action.submitStatus
      };
    default:
      return state;
  }
}
